<template>
    <div class="date-range-picker">
        <label class="date-range-picker__label">{{label || trans('general.date_range')}}</label>
        <div class="date-range-picker__inputs">
            <div class="date-range-picker__field">
                <datepicker :bootstrapStyling="true" input-class="form-control date-range-picker__input" :value="startDate" :placeholder="trans('general.start_date')" :clear-button="clearButton" @selected="updateStartDate" @cleared="clearStartDate"></datepicker>
            </div>
            <div class="date-range-picker__field">
                <datepicker :bootstrapStyling="true" input-class="form-control date-range-picker__input" :value="endDate" :placeholder="trans('general.end_date')" @selected="updateEndDate" @cleared="clearEndDate"></datepicker>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {},
        props: ['startDate','endDate','label'],
        data(){
            return {
                clearButton: true
            }
        },
        methods: {
            updateStartDate(val){
                let date = helper.toDate(val);
                if(date > this.endDate)
                    this.$emit('update:endDate',date);
                this.$emit('update:startDate',date);
            },
            updateEndDate(val){
                let date = helper.toDate(val);
                if(!this.startDate || this.startDate > date)
                    this.$emit('update:startDate',date);
                this.$emit('update:endDate',date);
            },
            clearStartDate(){
                this.$emit('update:startDate','');
                this.$emit('update:endDate','');
            },
            clearEndDate(){
                this.$emit('update:endDate','');
            }
        }
    }
</script>

<style lang="scss" scoped>
.date-range-picker {
    width: 100%;
    min-width: 0;
}

.date-range-picker__label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.4;
}

.date-range-picker__inputs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
    width: 100%;
}

.date-range-picker__field {
    min-width: 0;
    width: 100%;
}

.date-range-picker__field :deep(.vdp-datepicker) {
    width: 100%;
}

.date-range-picker__field :deep(.vdp-datepicker input),
.date-range-picker__field :deep(.date-range-picker__input) {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}

@media (max-width: 767px) {
    .date-range-picker__inputs {
        grid-template-columns: 1fr;
    }
}
</style>
